import { Lang } from './components/localize-context';
import { ServiceDiscount } from './shared-types';

export function getLocalizedSlug(language: Lang, pathname: string) {
  const prefix = language === 'en-us' ? '' : '/' + language.split('-')[0];
  const pathParts = pathname.split('/');
  const urlWithoutPrefix =
    pathParts[1] === 'zh' ? '/' + pathParts.slice(2).join('/') : pathname;
  const result = prefix + (urlWithoutPrefix === '/' ? '' : urlWithoutPrefix);
  return result === '' ? '/' : result;
}

type ScrollToOptions = {
  offset?: number;
  container?: Element | Window;
  contentRoot?: HTMLElement;
};

export function scrollToTarget(
  target: Element | null,
  {
    offset = 68,
    container = window,
    contentRoot = document.body,
  }: ScrollToOptions = {}
) {
  if (target) {
    const bodyPosition = contentRoot.getBoundingClientRect().top;
    const elementPosition = target.getBoundingClientRect().top - bodyPosition;
    const offsetPosition = elementPosition - offset;

    try {
      container.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    } catch (e) {
      console.error(e);
    }
  }
}

export function isFilledArray(array: unknown[]) {
  return array.length > 0;
}

export function lastItem<T>(array: T[]): T {
  return array[array.length - 1];
}

export const parseNumber = (numString: string) => {
  const num = Number(numString);
  return isNaN(num) ? 0 : num;
};

export const getNumberParts = (num: number) => {
  const integer = Math.floor(num);
  const decimal = num - integer;

  return [integer, decimal.toFixed(2).replace(/^0\./, '')] as const;
};

export const determinePrice = (
  discounts: ServiceDiscount[],
  oriAdultPrice: number,
  oriKidPrice: number,
  totalPeople: number
) => {
  let result: [number, number] = [oriAdultPrice, oriKidPrice];
  let sortedDiscounts = discounts
    .slice()
    .sort((a, b) => a.requiredUnit - b.requiredUnit);

  for (const discount of sortedDiscounts) {
    if (discount.requiredUnit <= totalPeople) {
      result = [discount.adultPrice, discount.kidPrice];
    } else {
      break;
    }
  }

  return result;
};

type Callback<Args extends any[]> = (...args: Args) => void;

export function callAll<Args extends any[]>(
  ...fns: Array<Callback<Args> | undefined>
) {
  return function callAllFns(...args: Args) {
    fns.forEach(fn => typeof fn === 'function' && fn(...args));
  };
}

export function isDefined<T>(value: T | undefined): value is T {
  return typeof value !== 'undefined';
}
